import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const RemoveEmbeddedFonts = () => {
  const faqs = [
    {
      question: "Q: What does “Remove Embedded Fonts” feature do?",
      answer:
        "A: It removes embedded fonts from uploaded PDFs or ZIPs, ensuring USPTO compliance and reducing the risk of rejection.",
    },
    {
      question: "Q: What file types are supported ? ",
      answer:
        "A: You can upload PDF files or ZIP files containing multiple PDFs.",
    },
    {
      question: "Q: What are the file size and upload limits ?",
      answer:
        "A: For Embedded Font Removal, JUNE supports files up to 100 MB in size, with a maximum of 15 files per batch and up to 500 pages per file.",
    },
    {
      question: "Q: Will the content or formatting of my file change ?",
      answer:
        "A: Only the embedded fonts are removed. The document’s content and formatting remain intact, so your submission version looks the same but meets USPTO standards.",
    },
    {
      question: "Q: What happens if my file exceeds the limits ?",
      answer:
        "A: If your file is larger than the supported limits, the system will notify you. You may need to split your document into smaller files before retrying.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {typeof faq.answer === "string" ? (
              <Typography sx={{ whiteSpace: "pre-line" }}>{faq.answer}</Typography>
            ) : (
              faq.answer
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default RemoveEmbeddedFonts;
